import Vue from 'vue';
import { Module } from 'vuex';

import { Nullable, RootState } from 'frontend/types';
import { LessonAutosave } from 'frontend/types/lessons/editor';

interface LessonAutosaveState {
  lastAutosave: Nullable<LessonAutosave>;
}

const lastAutosave: Module<LessonAutosaveState, RootState> = {
  namespaced: true,
  state: {
    lastAutosave: null,
  },

  mutations: {
    setValue(state: LessonAutosaveState, value: LessonAutosave) {
      Vue.set(state, 'lastAutosave', value);
    },
    clearValue(state: LessonAutosaveState) {
      state.lastAutosave = null;
    },
  },

  actions: {
    clearLastAutosave({ commit }) {
      commit('clearValue');
    },
  },
};

export default lastAutosave;
